import type { DocLink, DocLinkInput } from 'owa-graph-schema';

export function convertDocLinkGqlTypeToGqlInput(docLink: DocLink): DocLinkInput {
    return {
        ProviderType: docLink.ProviderType,
        Url: docLink.Url,
        PermissionType: docLink.PermissionType,
    };
}
